/**
 * Set up routes for our application.
 */
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, useHistory, Switch } from 'react-router-dom';
import { SecureRoute, Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';

import withErrorBoundary from './hocs/withErrorBoundary';
import App from './App';
import LoadingIndicator from './components/LoadingIndicator';

const oktaAuth = new OktaAuth({
  issuer: 'https://inform.okta.com/oauth2/default',
  clientId: '0oaxuwrp5mnAYK9tT0x7',
  redirectUri: window.location.origin + '/login/callback',
});

const HomePage = lazy(() => import('./containers/HomePage'));
const NotFound = lazy(() => import('./containers/NotFound'));

function LoadingRoute() {
  return <LoadingIndicator />;
}

function Routes() {
  const history = useHistory();
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <App>
        <Suspense fallback={<LoadingRoute />}>
          <Switch>
            <SecureRoute exact path="/">
              <HomePage />
            </SecureRoute>

            <Route path="/login/callback">
              <LoginCallback />
            </Route>

            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Suspense>
      </App>
    </Security>
  );
}

const AppWithRouterAccess = () => (
  <Router>
    <Routes />
  </Router>
);

export default withErrorBoundary(AppWithRouterAccess);
